const nasobilkaPeti = () => {
	return [
		{
			id: 1,
			priklad: '0 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '0',
				},
				{
					id: 2,
					moznost: '1',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '0',
		},
		{
			id: 2,
			priklad: '0 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '1',
				},
				{
					id: 3,
					moznost: '0',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '0',
		},
		{
			id: 3,
			priklad: '1 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '15',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '1',
				},
			],
			vysledek: '5',
		},
		{
			id: 4,
			priklad: '3 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '15',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '15',
		},
		{
			id: 5,
			priklad: '4 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '25',
				},
				{
					id: 2,
					moznost: '15',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '20',
		},
		{
			id: 6,
			priklad: '6 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '40',
				},
				{
					id: 4,
					moznost: '25',
				},
			],
			vysledek: '30',
		},
		{
			id: 7,
			priklad: '10 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '40',
				},
				{
					id: 2,
					moznost: '50',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '35',
				},
			],
			vysledek: '50',
		},
		{
			id: 8,
			priklad: '7 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '35',
		},
		{
			id: 9,
			priklad: '5 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '35',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '30',
				},
			],
			vysledek: '45',
		},
		{
			id: 10,
			priklad: '5 x 10',
			moznosti: [
				{
					id: 1,
					moznost: '35',
				},
				{
					id: 2,
					moznost: '40',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '50',
				},
			],
			vysledek: '50',
		},
		{
			id: 11,
			priklad: '50 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '10',
		},
		{
			id: 12,
			priklad: '40 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 13,
			priklad: '10 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '2',
		},
		{
			id: 14,
			priklad: '15 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '4',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '3',
		},
		{
			id: 15,
			priklad: '30 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '5',
				},
			],
			vysledek: '6',
		},
		{
			id: 16,
			priklad: '40 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '8',
		},
		{
			id: 17,
			priklad: '25 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '5',
		},
		{
			id: 18,
			priklad: '35 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '5',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '7',
		},
		{
			id: 19,
			priklad: '45 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '9',
		},
		{
			id: 20,
			priklad: '50 : 5',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '10',
		},
		{
			id: 21,
			priklad: '5 x 1',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '15',
				},
			],
			vysledek: '5',
		},
		{
			id: 22,
			priklad: '5 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '25',
				},
				{
					id: 3,
					moznost: '20',
				},
				{
					id: 4,
					moznost: '15',
				},
			],
			vysledek: '15',
		},
		{
			id: 23,
			priklad: '5 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '20',
				},
				{
					id: 2,
					moznost: '25',
				},
				{
					id: 3,
					moznost: '30',
				},
				{
					id: 4,
					moznost: '15',
				},
			],
			vysledek: '20',
		},
		{
			id: 24,
			priklad: '5 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '40',
				},
				{
					id: 4,
					moznost: '45',
				},
			],
			vysledek: '35',
		},
		{
			id: 25,
			priklad: '9 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '50',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '45',
				},
				{
					id: 4,
					moznost: '40',
				},
			],
			vysledek: '45',
		},
	];
};

export default nasobilkaPeti;
